import selectableRowContentUrl from './selectable-row-content.html';

class SelectableRowContentCtrl {
  constructor(PersonaCollection) {
    'ngInject';

    Object.assign(this, { PersonaCollection });
  }

  $onInit() {
    if (this.shift) {
      const { id: positionId } = this.shift.position;
      const position = this.PersonaCollection.personasDict[positionId];
      this.positions = position ? [position] : [];

      const { id: locationId } = this.shift.location;
      const location = this.PersonaCollection.personasDict[locationId];
      this.locations = location ? [location] : [];
    } else {
      this.positions = this.persona.positions;
      this.locations = this.persona.locations;
    }
    this.user = 'avatar' in this.persona ? this.persona : this.persona.user;
  }
}

export default {
  controller: SelectableRowContentCtrl,
  controllerAs: 'ctrl',
  bindings: {
    includeAvatar: '=',
    label: '<',
    persona: '<',
    shift: '<',
  },
  templateUrl: selectableRowContentUrl,
};
